import styled from 'styled-components';
import cloudImage from '../images/cloud.png';
import dataEngineeringImage from '../images/dataEngineer.png';
import security from '../images/security.png';
import agile  from '../images/agile.png';
import db from '../images/db.png';


const services = [
  {
    title: "Conseil en Cloud Computing",
    description: `Accélérez votre transformation digitale avec nos solutions cloud natives. Notre expertise optimise vos coûts et sécurise vos données.
    
    Notre équipe vous guide dans la migration cloud, l'optimisation des ressources et la gestion de vos infrastructures pour des performances maximales.`,
    image: cloudImage
  },
  {
    title: "Ingénierie des Données",
    description: `Libérez la puissance de vos données avec nos solutions d'ingénierie avancées. Notre expertise en Big Data transforme vos informations en insights stratégiques.
    
    Nous concevons et implémentons des pipelines de données robustes pour maximiser la valeur de vos ressources digitales.`,
    image: db
  },
  {
    title: "Architecture Data",
    description: `Créez une infrastructure données évolutive et performante. De la conception à l'implémentation, nos architectures s'adaptent à vos enjeux.
    
    Notre approche sur mesure intègre les dernières technologies Big Data, NoSQL et analytique temps réel pour répondre à vos objectifs business.`,
    image: cloudImage
  },
  {
    title: "Gouvernance des Données",
    description: `Maîtrisez vos données avec une gouvernance robuste et efficace. Nos solutions garantissent qualité, sécurité et conformité.
    
    Nos experts implémentent des stratégies de gouvernance adaptées à votre contexte, assurant une gestion proactive et valorisante de votre patrimoine data.`,
    image: security
  },
  {
    title: "Automatisation",
    description: `Optimisez vos processus avec l'automatisation intelligente. Accélérez vos cycles de développement et déploiement avec nos solutions DevOps.
    
    Notre expertise en GitOps, Jenkins, Docker et Kubernetes améliore la fiabilité de vos systèmes et la qualité de vos livrables.`,
    image: cloudImage
  },
  {
    title: "Accompagnement en Méthodes Agiles",
    description: `Adoptez l'agilité pour une transformation digitale réussie. Nos coaches experts vous guident dans l'adoption des méthodes Scrum et Kanban.
    
    Nous collaborons étroitement avec vos équipes pour implémenter des pratiques agiles adaptées à votre culture d'entreprise.`,
    image: agile
  }
 ];



const Services = () => (
  <ServicesContainer>
  <Header> 
    <h1>Solutions Technologiques<br />sur Mesure</h1>
    <p>De la stratégie à l'implémentation, nos experts vous accompagnent dans 
    la transformation de votre infrastructure digitale avec des solutions 
    innovantes et évolutives.</p>
  </Header>

  <ServicesList>
  {services.map((service, index) => (
    <ServiceItem key={index}>
      <ImageContainer className="image-container">
        <img src={service.image} alt={service.title} />
      </ImageContainer>
      <div className="content">
        <h2>{service.title}</h2>
        <p>{service.description}</p>
      </div>
    </ServiceItem>
  ))}
</ServicesList>

  {/* Partenaires et Call-to-action sections 
  <PartnersSection />
  <CallToAction />*/}

</ServicesContainer>
);


export default Services;


const ServicesContainer = styled.div`
  min-height: 100vh;
  color: white;
`;

const Header = styled.header`
  text-align: center;
  padding: 4rem 1rem;

  h1 {
    font-size: 3rem;
    margin-bottom: 1.5rem;
  }

  p {
    color: #94a3b8;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
`;

const ServicesList = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const ImageContainer = styled.div`
  position: relative;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    object-fit: contain;
    max-height: 300px;
  }
`;

const ServiceItem = styled.div`
 display: grid;
 grid-template-columns: 1fr 1fr;
 gap: 4rem;
 margin-bottom: 8rem;
 align-items: center;
 padding: 0 2rem;

 .content {
   h2 {
     font-size: 2rem;
     margin-bottom: 2rem; // Augmentation de l'espacement
     color: #fff; // Pour s'assurer que le titre est bien visible
     font-weight: 600; // Optionnel: pour un titre plus prononcé
   }

   p {
     color: #94a3b8;
     line-height: 1.8;
     margin-bottom: 1.5rem;
   }
 }

 &:nth-child(odd) {
   ${ImageContainer} {
     order: 1;
   }
   .content {
     order: 2;
     text-align: left;
   }
 }

 &:nth-child(even) {
   ${ImageContainer} {
     order: 2;
   }
   .content {
     order: 1;
     text-align: left;
   }
 }

 @media (max-width: 768px) {
   grid-template-columns: 1fr;
   gap: 2rem;
   
   &:nth-child(odd),
   &:nth-child(even) {
     ${ImageContainer}, .content {
       order: unset;
       text-align: center;
     }
   }
 }
`;
